export default __webpack_public_path__ + "static/media/Training_CommonMenu.a076f4f4.svg";